import { Stack, Switch, Typography, useTheme } from "@mui/material";

export type FlatRowSwitchProps = {
	label: string;
	checked?: boolean;
	onChange?: (checked: boolean) => void;
	onBlur?: () => void;
	disabled?: boolean;
	isLast?: boolean;
	redesigned?: boolean;
};

export const FlatRowSwitch = ({
	label,
	checked,
	onChange,
	onBlur,
	disabled,
	isLast,
	redesigned = false,
}: FlatRowSwitchProps) => {
	const theme = useTheme();

	return (
		<Stack
			component="label"
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			sx={{
				width: "100%",
				px: 1.6,
				minHeight: 48,
				cursor: disabled ? "default" : "pointer",
				borderBottom: isLast ? "none" : theme.colors.border.flatRowDivider,
			}}
		>
			<Typography variant="body2" mr={2}>
				{label}
			</Typography>
			<Switch
				redesigned={redesigned}
				checked={!!checked}
				onChange={(_, next) => onChange?.(next)}
				onBlur={onBlur}
				disabled={disabled}
			/>
		</Stack>
	);
};
